import { useState, useCallback } from 'react';
import { get, post, put, del } from '../../utils/networkUtils';

export const useLeagues = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get all leagues
  const fetchLeagues = useCallback(async (leagueType = 'custom') => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/leagues?league_type=${leagueType}`);
      return response.leagues;
    } catch (err) {
      setError(err.message || 'Failed to fetch leagues');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Get single league by ID
  const fetchLeagueById = useCallback(async (leagueId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(`/admin/leagues/${leagueId}`);
      return response.league;
    } catch (err) {
      setError(err.message || 'Failed to fetch league');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Create new league
  const createLeague = useCallback(async (leagueData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await post('/admin/leagues', leagueData);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to create league');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Update league
  const updateLeague = useCallback(async (leagueId, leagueData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await put(`/admin/leagues/${leagueId}`, leagueData);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to update league');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Delete league
  const deleteLeague = useCallback(async (leagueId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await del(`/admin/leagues/${leagueId}`);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to delete league');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchLeagues,
    fetchLeagueById,
    createLeague,
    updateLeague,
    deleteLeague,
  };
};
